<template>
  <div class="docs">
    <ui-title>{{ t('docs.terms.title') }}</ui-title>
    <div class="container">
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script setup>
import UiTitle from "@/components/ui/ui-title.vue";
import {onMounted, ref, watch} from 'vue'
import {Docs} from "@/core/api/docs.js";
import {useI18n} from "vue-i18n";

const {t, locale} = useI18n()

const content = ref(null)

const getDocs = async () => {
  const res = await Docs.getDocs("terms-of-use")

  if (res.data.posts.edges.length) {
    content.value = res.data.posts.edges[0].node.content
  }
}

watch(locale, async () => {
  await getDocs()
})

onMounted( async () => {
  await getDocs()
})
</script>

<style lang="scss" scoped>
.docs {

}


//:deep(h1) {
//  font-size: 4.4rem;
//  font-family: Montserrat Bold,sans-serif;
//}
//:deep(h2) {
//  font-family: Montserrat Medium,sans-serif;
//  font-size: 2rem;
//}
//:deep(li) {
//  line-height: 120%;
//  font-size: 1.8rem;
//  font-family: Montserrat Medium,sans-serif;
//}
//:deep(p) {
//  line-height: 120%;
//  font-size: 1.8rem;
//  font-family: Montserrat Medium,sans-serif;
//}
:deep(ul) {
  padding-left: 30px;
}
:deep(a) {
  color: #ff6162;
  transition: 0.2s;

  @include hover {
    color: #fc4546;
  }
}
</style>